 <template>
  <div>
    <h2>Output for "onClick" event</h2>
    <br />
    <v-card>
      <v-card-title>Value : {{ msg }}</v-card-title>
      <v-card-text>
        <v-text-field
          solo-inverted
          v-model="welcomeMsg"
          placeholder="Enter the value"
        />
        <v-btn @click="changeMsg" color="primary">Update Value</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

    <script>
/* eslint-disable */
export default {
  name: "CustomEvent",
  data() {
    return {
      welcomeMsg: "",
    };
  },
  props: {
    msg: String,
  },
  methods: {
    changeMsg() {
      this.$emit("changeMsg", this.welcomeMsg);
    },
  },
};
</script>